var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAptos = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_25365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_331_25365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_331_25365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7601 21.7602H-0.760254V-0.760193H21.7601V21.7602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_331_25365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7857 10.5C20.7857 16.1826 16.1825 20.7858 10.4999 20.7858C4.81731 20.7858 0.214111 16.1826 0.214111 10.5C0.214111 4.81743 4.81731 0.214233 10.4999 0.214233C16.1825 0.214233 20.7857 4.81743 20.7857 10.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_331_25365)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_331_25365",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.209961V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_331_25365)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "matrix(1 0 0 -1 0 21)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_331_25365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0639 8.47541H12.9615C12.833 8.47541 12.7108 8.42029 12.6258 8.32435L12.1786 7.81917C12.1121 7.74377 12.0161 7.70087 11.9158 7.70087C11.8154 7.70087 11.7195 7.74403 11.6529 7.81917L11.2694 8.25259C11.1438 8.39429 10.9636 8.47567 10.7744 8.47567H4.74002C4.56816 8.96551 4.4561 9.48291 4.41138 10.0195H10.108C10.2081 10.0195 10.304 9.97873 10.3732 9.90645L10.9036 9.35291C10.9699 9.28375 11.0614 9.24475 11.1571 9.24475H11.1789C11.2795 9.24475 11.3752 9.28791 11.4418 9.36331L11.8887 9.86849C11.9737 9.96469 12.0959 10.0195 12.2244 10.0195H16.8742C16.8295 9.48265 16.7174 8.96525 16.5456 8.47567H14.0636L14.0639 8.47541Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.85835 13.2662C7.95845 13.2662 8.05439 13.2253 8.12355 13.1531L8.65395 12.5995C8.72025 12.5304 8.81177 12.4914 8.90745 12.4914H8.92929C9.02991 12.4914 9.12559 12.5345 9.19215 12.6097L9.63909 13.1148C9.72411 13.211 9.84631 13.2659 9.97475 13.2659H16.2761C16.5122 12.7781 16.6851 12.2548 16.7881 11.7064H10.7397C10.6112 11.7064 10.489 11.6513 10.404 11.5554L9.95707 11.0502C9.89051 10.9748 9.79457 10.9319 9.69421 10.9319C9.59385 10.9319 9.49791 10.975 9.43135 11.0502L9.04785 11.4836C8.92227 11.6253 8.74209 11.7067 8.55255 11.7067H4.49707C4.60003 12.255 4.77319 12.7784 5.00901 13.2662H7.85835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3288 6.78824C12.4289 6.78824 12.5248 6.74742 12.594 6.67514L13.1244 6.1216C13.1907 6.05244 13.2822 6.01344 13.3779 6.01344H13.3997C13.5003 6.01344 13.596 6.0566 13.6626 6.132L14.1095 6.63718C14.1945 6.73338 14.3167 6.78824 14.4452 6.78824H15.6435C14.5024 5.2714 12.6873 4.29016 10.6427 4.29016C8.59805 4.29016 6.78299 5.2714 5.64185 6.78824H12.3288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.92194 14.8116H8.28316C8.15472 14.8116 8.03252 14.7565 7.9475 14.6605L7.50056 14.1553C7.434 14.0799 7.33806 14.037 7.2377 14.037C7.13734 14.037 7.0414 14.0802 6.97484 14.1553L6.59134 14.5888C6.46576 14.7305 6.28558 14.8118 6.09604 14.8118H6.07056C7.21222 16.0351 8.838 16.8008 10.6432 16.8008C12.4484 16.8008 14.0739 16.0351 15.2158 14.8118H9.92194V14.8116Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_25365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_331_25365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAptos);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/aptos.1149abfdae9fdbbb83f320505a3a67d1.svg";